var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleIconGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3 3.832C14.14 2.818 14.704 1.405 14.55 0C13.342 0.049 11.88 0.805 11.015 1.819C10.238 2.717 9.55796 4.154 9.74196 5.531C11.088 5.636 12.464 4.847 13.302 3.832H13.3ZM16.322 12.75C16.356 16.382 19.508 17.591 19.542 17.607C19.517 17.692 19.04 19.329 17.882 21.02C16.882 22.482 15.844 23.939 14.208 23.969C12.601 23.998 12.085 23.016 10.247 23.016C8.41096 23.016 7.83696 23.939 6.31496 23.998C4.73696 24.058 3.53496 22.417 2.52496 20.961C0.46496 17.981 -1.11004 12.541 1.00496 8.869C2.05396 7.045 3.93196 5.89 5.96996 5.861C7.51996 5.831 8.98296 6.904 9.92996 6.904C10.878 6.904 12.656 5.614 14.525 5.803C15.308 5.836 17.504 6.119 18.915 8.184C18.801 8.254 16.294 9.714 16.321 12.75",
    fill: "#6B7888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIconGrey);
export default __webpack_public_path__ + "static/media/AppleIconGrey.3733cf6c373047a0c79f304749c228b5.svg";
export { ForwardRef as ReactComponent };